export const avatarUploadError = state => state.user.avatarUploadError

export const videos = state => state.user.videos

export const ssoProvisionData = state => state.user.ssoProvisionData
